import React from "react";
import BaseReportPage from "./_BaseReportPage";

const columns = [
  { title: "Date", key: "date" },
  { title: "Code", key: "employee_code" },
  { title: "Name", key: "name" },
  { title: "Department", key: "department" },
  { title: "Outlet", key: "outlet" },
  {
    title: "Shift",
    key: "shift_timing",
    render: (v, row) => `${row.shift_in} - ${row.shift_out}`,
  },
  { title: "In", key: "in_time" },
  { title: "Out", key: "out_time" },
  { title: "Status", key: "status" },
  { title: "Worked", key: "worked_minutes" },
  {
    title: "Remark",
    key: "remarks",
  },
];

export default function AttendanceReportPage() {
  return (
    <BaseReportPage
      apiEndpoint="/hrms/attendance"
      columns={columns}
      title="Attendance Report"
      emptyMessage="Please generate report by selecting a date."
      downloadEndpoint="/hrms/attendance/download"
    />
  );
}
